import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../contexts/AuthContext';


const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
    const { user, loading } = useAuthContext();

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!user) {
        // Redirect to the home page if the user is not authenticated
        return <Navigate to="/" />;
    }

    return children;
};

export default ProtectedRoute;